export const customerColumns = [
  // {
  //   id: "id",
  //   label: "Customer ID",
  //   editable: false,
  //   type: "number",
  //   width: "150",
  //   show: true,
  //   resizable: true,
  // },
  {
    id: "fullname",
    label: "Full Name",
    editable: false,
    type: "text",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "business_name",
    label: "Business",
    editable: false,
    type: "text",
    width: "250",
    show: true,
    resizable: true,
  }
];
